import {Component} from 'react'
import {AppLoadedProps} from '.'

export class AppLoaded extends Component<AppLoadedProps> {
  componentDidMount() {
    if (this.props.viewMode === 'Site') {
      this.props.widgetLoaded(this.props.isHomePage)
    }
  }

  render() {
    return null
  }
}
